import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { message } from 'antd'
import { updateSiteConfigs } from 'actions/Site'
import { fetchUsers, deleteUser } from 'actions/Users'
import UserListView from 'components/pages/users'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchUsers: bindActionCreators(fetchUsers, dispatch),
  deleteUser: bindActionCreators(deleteUser, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isLoading', 'setIsLoading', false),
  withState('stateSearch', 'setStateSearch', {}),
  withState('data', 'setData', {}),
  withHandlers({
    getList: props => async (params) => {
      const { setData, setIsLoading } = props
      setIsLoading(true)
      try {
        const res = await props.fetchUsers(params)
        setData({
          list: res.data,
          meta: res.meta,
        })
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  withHandlers({
    handleDelete: props => async (id) => {
      const { setIsLoading, getList } = props
      setIsLoading(true)

      try {
        const res = await props.deleteUser(id)
        message.success(res)
        getList()
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
    handleChangePage: props => (val) => {
      const { getList } = props
      getList(`?page=${val}`)
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Daftar Pengguna',
        activePage: 'user/list',
        activeSubPage: 'user',
      })

      this.props.getList()
    },
  }),
)(UserListView)
